import { useTheme } from './useTheme';

type ThemedColor = Record<Exclude<DashboardTheme, 'auto'>, string>;

const useThemedColor = (themedColors: ThemedColor): string => {
  const theme = useTheme();
  return themedColors[theme];
};

export { useThemedColor };
export type { ThemedColor };
